import { CoverablesService } from 'gw-capability-codegen';
import _ from 'lodash';
import { useCallback } from 'react';

export default ({
    coverableVM,
    coverableType,
    jobID,
    sessionUUID,
    lobName,
    owningCoverablePublicID,
    updateIsSaving,
    isSavingRef,
    authHeader,
}) => {
    const saveCoverable = useCallback(async () => {
        if (!isSavingRef.current) {
            updateIsSaving(true);
            const newCoverable = _.get(coverableVM, 'value', {});
            newCoverable.owningCoverablePublicID =
                newCoverable.owningCoverablePublicID || owningCoverablePublicID;
            const endpoint = newCoverable.publicID ? 'update' : 'add';
            const coverableResponse = await CoverablesService.callMethod(
                lobName,
                coverableType,
                endpoint,
                [jobID, sessionUUID, newCoverable],
                authHeader
            );
            // eslint-disable-next-line no-param-reassign
            coverableVM.value = coverableResponse;
            updateIsSaving(false);
        }
    }, [
        coverableType,
        coverableVM && coverableVM.value,
        jobID,
        lobName,
        owningCoverablePublicID,
        sessionUUID,
    ]);

    const handleFieldBlur = useCallback(async () => {
        if (coverableVM && coverableVM.aspects.subtreeValid) {
            await saveCoverable();
        }
    }, [coverableVM]);

    return {
        saveCoverable,
        handleFieldBlur,
    };
};
